import { CreateOrderRequest, OrderDiscount } from '@models/order';
import { PayloadAction, WritableDraft } from '@reduxjs/toolkit';

// 특정 쿠폰 ID 하나만 제거 (토글 시 먼저 호출하여 기존 상태 초기화)
export function removeCoupon(
    state: WritableDraft<CreateOrderRequest>,
    action: PayloadAction<string>,
) {
    state.discounts = state.discounts?.filter((d) => d.couponId !== action.payload);
}

// COUPON 타입 전체 제거 (포인트 등 다른 타입의 할인은 유지)
export function clearCoupons(state: WritableDraft<CreateOrderRequest>, _: PayloadAction) {
    state.discounts = state.discounts?.filter((d) => d.type !== 'COUPON');
}

// 전달된 배열로 discounts를 교체 (쿠폰 적용 시 단일 쿠폰만 허용하는 구조를 유지하기 위해 배열 전체를 덮어씀)
export function setDiscounts(
    state: WritableDraft<CreateOrderRequest>,
    action: PayloadAction<OrderDiscount[]>,
) {
    state.discounts = action.payload;
}
